import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AggregateDataType } from 'lavva.exalushome/build/js/Services/StatesHistory/StatesHistory';
import { isEmpty } from 'lodash';
import { IconSchedule } from '../../../../../../../assets/icons/icon-schedule';
import { MeasurementRange } from '../../../../../../../types';
import './index.scss';

type ChartSummaryProps = {
  activeRange: MeasurementRange;
  aggregateData?: Map<AggregateDataType, any>;
  unit?: string;
};

const ChartSummary: React.FC<ChartSummaryProps> = ({ activeRange, aggregateData, unit = '' }) => {
  const { t } = useTranslation('channel-details');

  const summarySectionName = useMemo(() => {
    switch (activeRange) {
      case MeasurementRange.DayInHours:
        return t('summary.daily');
      case MeasurementRange.WeekInDays:
        return t('summary.weekly');
      case MeasurementRange.MonthInDays:
        return t('summary.monthly');
      default:
        return '';
    }
  }, [activeRange]);

  const formatMeasurementValue = (dataType: AggregateDataType): string => {
    const value = aggregateData?.get(dataType);
    return value != null ? `${value} ${unit}` : '-';
  };

  const renderMeasurement = (labelKey: string, dataType: AggregateDataType) => (
    <div className="chart-summary__measurement">
      <span>{t(labelKey)}</span>
      <span>{formatMeasurementValue(dataType)}</span>
    </div>
  );

  return (
    <>
      {!isEmpty(aggregateData) && (
        <div className="chart-summary p-l-24 p-r-24 max-width-desktop">
          <div className="chart-summary__caption">
            <IconSchedule />
            <span className="chart-summary__caption-text"> {summarySectionName}</span>
          </div>
          {renderMeasurement('summary.min', AggregateDataType.Min)}
          {renderMeasurement('summary.average', AggregateDataType.Avg)}
          {renderMeasurement('summary.max', AggregateDataType.Max)}
        </div>
      )}
    </>
  );
};

export default ChartSummary;
